import WidgetStats from "components/modules/dashboard/WidgetStats";
import SalesArea from "components/modules/dashboard/SalesArea";
import FinancialArea from "components/modules/dashboard/FinancialArea";
import DashNav from "components/modules/dashboard/v2/DashNav";

const PharmacyDashboard = () => {
  return (
    <div className="dash-v2 mb-9">
      <DashNav />

      <div className="dash-section">
        <WidgetStats />
      </div>

      <div className="dash-section">
        <SalesArea />
      </div>

      <div className="dash-section">
        <FinancialArea />
      </div>
    </div>
  );
};

export default PharmacyDashboard;
